export default __webpack_public_path__ + "static/cust_factory-44a07c073ea974ad55f2c023d5cbb3f7.webp";